import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ClinicianReviewItemView } from "@/features/clinician/review-queue/components/ClinicianReviewItemView";

export function ClinicianReviewItemPage() {
  const { itemId = "" } = useParams<{ itemId: string }>();
  const navigate = useNavigate();
  // Opened from My Items (/clinician/my-items/:id) → back to My Items; otherwise the Review Queue.
  const fromMyItems = useLocation().pathname.startsWith("/clinician/my-items/");
  const backTo = fromMyItems ? "/clinician/my-items" : "/clinician";
  const back = () => navigate(backTo);
  // Keyed per item so nothing from one item's screen survives into the next.
  return (
    <ClinicianReviewItemView
      key={itemId}
      itemId={itemId}
      backLabel={fromMyItems ? "My Items" : "Review Queue"}
      onBack={back}
      onReleased={back}
      onDecided={back}
    />
  );
}
